export default __webpack_public_path__ + "static/media/icon-tic.8e21245d.svg";